import type { InferResponseType } from 'hono/client';
import { type ApiClient, useFetch } from '../api';

type ListRepositories =
  ApiClient['v1']['workspaces'][':workspaceId']['registry']['repositories']['$get'];
export type RepositoryListResponse = InferResponseType<ListRepositories, 200>;

export function useRepositories(workspaceId: number) {
  return useFetch<RepositoryListResponse>(`workspaces/${workspaceId}/services/`, (client) =>
    client.v1.workspaces[':workspaceId'].registry.repositories.$get({
      param: { workspaceId: workspaceId.toString() },
      query: { limit: '100' },
    })
  );
}
